import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadcrumbItem {
	name: string;    // The text to display
	isActive: boolean;  // Whether this is clickable or not
	route?: string;  // The route to navigate to when clicked (only for active items)
	queryParams?: { [key: string]: any };  // Optional query parameters for the route
	state?: { [key: string]: any };  // Optional state to pass to the route
}

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
	standalone: true,
	imports: [CommonModule, RouterModule]
})
export class BreadcrumbComponent {
	@Input() items: BreadcrumbItem[] = [];
} 